module.exports = __webpack_public_path__ + "static/img/qnset3.ca53535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnset3.png
// module id = 357
// module chunks = 0